import * as THREE from 'three';
import GUI from 'lil-gui';
import gsap from 'gsap';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

/**  * Debug  */
// const gui = new GUI()
// const parameters = {
//     scale: 1
// };
// const parameters = {
//     pipColor: '#ffd500',
//     materialColor1: '#FFFFFF',
//     materialColor: '#FFFFFF'
// }

// gui
//     .addColor(parameters, 'materialColor1')
//     .onChange(() => {
//         objectsToUpdate.forEach((mesh) => {
//             if (mesh.material && mesh.custom && mesh.recolor) {
//                 console.log(mesh.custom)
//                 mesh.material.color.set(parameters.materialColor1)
//             }
//         })
//     })
// gui
//     .addColor(parameters, 'pipColor')
//     .onChange(() => {
//         objectsToUpdate.forEach((mesh) => {
//             if (mesh.material && !mesh.custom && mesh.recolor) {
//                 console.log(mesh.custom)
//                 mesh.material.color.set(parameters.pipColor)
//             }
//         })
//     })


/** * Base */
const canvas = document.querySelector('canvas.webgl')   // Canvas
const scene = new THREE.Scene()             // Scene

// Objects
const objectsDistance = 4

/** * Textures */
const loadingManager = new THREE.LoadingManager()
const textureLoader = new THREE.TextureLoader(loadingManager)
const cubeTextureLoader = new THREE.CubeTextureLoader()
const environmentMapTexture = cubeTextureLoader.load([
    `/textures/environmentMaps/0/px.png`,
    `/textures/environmentMaps/0/nx.png`,
    `/textures/environmentMaps/0/py.png`,
    `/textures/environmentMaps/0/ny.png`,
    `/textures/environmentMaps/0/pz.png`,
    `/textures/environmentMaps/0/nz.png`
])

// environmentMapTexture.minFilter = THREE.LinearFilter
environmentMapTexture.magFilter = THREE.LinearFilter
environmentMapTexture.minFilter = THREE.LinearMipMapLinearFilter; // Example filter

const swirlTextureBW = textureLoader.load('/textures/SWIRL.png')
const swirlTexture = textureLoader.load('/textures/SWIRL_color3.jpg')
swirlTexture.minFilter = THREE.NearestFilter
swirlTexture.magFilter = THREE.NearestFilter
swirlTexture.colorSpace = THREE.SRGBColorSpace

const material = new THREE.MeshBasicMaterial({
    map: swirlTexture,
    // color: new THREE.Color(parameters.materialColor)
    color: new THREE.Color(0xffffff)
});

// gui.addColor(parameters, 'materialColor').onChange(() => {
//     objectsToUpdate.forEach((mesh) => {
//         if (mesh.material && mesh.custom) {
//             mesh.material.color.set(parameters.materialColor);
//         }
//     });
// });

/** * Utils */
const objectsToUpdate = []
const gltfLoader = new GLTFLoader();

const diceMesh = ((positionX, positionY, dieNumber, model, scale) => {
    gltfLoader.load(

        `/models/${model}`,

        (gltf) => {
            const customModel = gltf.scene // Assuming the main object is the whole scene
            console.log(customModel)
            var i = 0
            /* NORMAL RAINBOW DIE */
            if (dieNumber == 2) {
                customModel.traverse((child) => {
                    if (child instanceof THREE.Mesh) {
                        // BODY COLOR
                        if (i != 2) {
                            child.material = new THREE.MeshNormalMaterial()
                            child.custom = true // Identify pips [F] vs sides [T]
                            child.recolor = false // Identify material to recolor
                            // PIP COLOR
                        } else {
                            child.material = new THREE.MeshStandardMaterial({
                                color: new THREE.Color(0xFFD500),
                                // color: new THREE.Color(0xffffff),
                                metalness: 1.0,
                                roughness: 0.1,
                                envMap: environmentMapTexture,
                                envMapIntensity: 0.5
                            });
                            child.custom = false // Identify pips vs sides
                            child.recolor = true // Identify material to recolor
                        }
                        objectsToUpdate.push(child)
                    }
                    i += 1
                })
                /* STANDARD DIE */
            } else if (dieNumber == 1) {

                customModel.traverse((child) => {
                    if (child instanceof THREE.Mesh) {
                        //alert(i)
                        if (i != 2) {
                            // Apply color1 to the main body and color2 to a specific part
                            child.material = new THREE.MeshStandardMaterial({
                                map: material.map,
                                metalness: 0.5,
                                roughness: 0.5,
                                envMap: environmentMapTexture,
                                envMap: environmentMapTexture,
                                envMapIntensity: 1.0,
                                metalnessMap: swirlTextureBW,
                                roughnessMap: swirlTextureBW,
                                ambientOcclusionTexture: swirlTextureBW,
                                alphaTexture: swirlTextureBW,
                                normalTexture: swirlTextureBW
                            });
                            child.custom = true // Identify pips vs sides
                            child.recolor = true // Identify material to recolor
                        } else {
                            child.material = new THREE.MeshStandardMaterial({
                                // child.material = new THREE.MeshNormalMaterial({
                                color: new THREE.Color(0xFF0000),
                                // color: new THREE.Color(0xffffff),
                                metalness: 0,
                                roughness: 0.1,
                                envMap: environmentMapTexture,
                                envMapIntensity: 0.5
                            });
                            child.custom = false // Identify pips vs sides
                            child.recolor = false // Identify material to recolor
                        }
                        objectsToUpdate.push(child)
                    }
                    i += 1
                })
            } else if (dieNumber == 0) {

                customModel.traverse((child) => {
                    if (child instanceof THREE.Mesh) {
                        //alert(i)
                        if (i != 2) {
                            child.material = new THREE.MeshStandardMaterial({
                                color: new THREE.Color(0x000000),
                                map: material.map,
                                metalness: 1.0,
                                roughness: 0.0,
                                envMap: environmentMapTexture,


                                envMapIntensity: 1.0,

                                metalnessMap: swirlTextureBW,
                                roughnessMap: swirlTextureBW,
                                ambientOcclusionTexture: swirlTextureBW,
                                alphaTexture: swirlTextureBW,
                                normalTexture: swirlTextureBW
                            });
                            child.custom = true // Identify pips vs sides
                            child.recolor = true // Identify material to recolor

                        } else {
                            child.material = new THREE.MeshStandardMaterial({
                                color: new THREE.Color(0xFFD500),
                                metalness: 1.0,
                                roughness: 0.1,
                                envMap: environmentMapTexture,
                                envMapIntensity: 0.5
                            });
                            child.custom = false // Identify pips vs sides
                            child.recolor = true // Identify material to recolor
                        }
                        objectsToUpdate.push(child)
                    }
                    i += 1
                })
            }
            scene.add(customModel)
            customModel.scale.set(scale,scale,scale)
            customModel.position.set(positionX, positionY, 0)
            customModel.rotation.set(0, 0, 0)
            

            // gui
            //     .add(parameters, 'scale', 0.1, 10)
            //     .name('Scale')
            //     .max(4)
            //     .onChange((value) => {
            //         customModel.scale.set(value, value, value);
            //     });
                
        },
        undefined,
        (error) => {
            console.error('Error loading GLTF model:', error)
        }
    )
})

diceMesh(2, -objectsDistance * 0, 0, 'dice_rounded6A.gltf',1.05)
diceMesh(-2, -objectsDistance * 1, 1, 'dice_rounded_ork2.gltf',1)
diceMesh(2, -objectsDistance * 2, 2, 'd20_v6a.gltf',1.5)
//dice_rounded6A.gltf
//d20_v6a.gltf'
const sectionMeshes = [1, 2, 3]
/** * Lights */
const directionalLight = new THREE.DirectionalLight('#ffffff', 3)
directionalLight.position.set(1, 1, 0)
// directionalLight.position.set(-1, 0,-1)
scene.add(directionalLight)

/** * Sizes */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/** * Camera */
const cameraGroup = new THREE.Group()
scene.add(cameraGroup)
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 6
cameraGroup.add(camera)

/** * Renderer */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true,
    antialias: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/** * Scroll */
let scrollY = window.scrollY
let currentSection = 0


// Utility function to interpolate between two colors
// const interpolateColor = (color1, color2, factor) => {
//     const result = color1.clone().lerp(color2, factor);
//     return result;
// }

const interpolateColor = (color1, color2, color3, factor) => {
    if (factor <= 0.5) {
        return color1.clone().lerp(color2, factor * 2);
    } else {
        return color2.clone().lerp(color3, (factor - 0.5) * 2);
    }
}
// Define start and end colors for background and text
// const bgColorEnd = new THREE.Color(0x1e1a20);
// const bgColorStart = new THREE.Color(0xffffff);
// const textColorStart = new THREE.Color(0xffffff);
// // const textColorEnd = new THREE.Color(0x000000);
// const textColorEnd = new THREE.Color(0xFFD500);

const bgColorStart = new THREE.Color(0xffffff);
const bgColorMiddle = new THREE.Color(0x280050); // Example third color
const bgColorEnd = new THREE.Color(0x1e1a20);

const textColorStart = new THREE.Color(0xffffff);
const textColorMiddle = new THREE.Color(0xff0000); // Example third color
const textColorEnd = new THREE.Color(0xFFD500);


const changeColorSetup = (() => {
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    const scrollFactor = scrollY / maxScroll;
    // Interpolate background color
    const bgColor = interpolateColor(bgColorStart, bgColorMiddle, bgColorEnd, scrollFactor);
    document.body.style.backgroundColor = `#${bgColor.getHexString()}`;

    // Interpolate text color
    const textColor = interpolateColor(textColorStart, textColorMiddle, textColorEnd, scrollFactor);
    document.body.style.color = `#${textColor.getHexString()}`;

    // Update other elements' text color if needed
    document.querySelectorAll('.section, .section h2, .section p').forEach(el => {
        el.style.color = `#${textColor.getHexString()}`;
    });
    
})
window.addEventListener('load', () => {
    scrollY = window.scrollY
    changeColorSetup()
    /* New Scroll Functionality */
    // const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    // const scrollFactor = scrollY / maxScroll;

    // // Interpolate background color
    // const bgColor = interpolateColor(bgColorStart, bgColorEnd, scrollFactor);
    // document.body.style.backgroundColor = `#${bgColor.getHexString()}`;

    // // Interpolate text color
    // const textColor = interpolateColor(textColorStart, textColorEnd, scrollFactor);
    // document.body.style.color = `#${textColor.getHexString()}`;

    // // Update other elements' text color if needed
    // document.querySelectorAll('.section, .section h2, .section p').forEach(el => {
    //     el.style.color = `#${textColor.getHexString()}`;
    // });
})
window.addEventListener('scroll', () => {
    scrollY = window.scrollY
    const newSection = Math.round(scrollY / sizes.height)
    console.log(newSection)
    if (newSection != currentSection) {
        currentSection = newSection
        if (currentSection == 0) {
            gsap.to(objectsToUpdate[2].rotation, { duration: 1.5, ease: 'power2.inOut', x: '+=6', y: '+=3', z: '+=1.5' })
            gsap.to(objectsToUpdate[3].rotation, { duration: 1.5, ease: 'power2.inOut', x: '+=6', y: '+=3', z: '+=1.5' })
        } else if (currentSection == 1) {
            gsap.to(objectsToUpdate[4].rotation, { duration: 1.5, ease: 'power2.inOut', x: '+=6', y: '+=3', z: '+=1.5' })
            gsap.to(objectsToUpdate[5].rotation, { duration: 1.5, ease: 'power2.inOut', x: '+=6', y: '+=3', z: '+=1.5' })
        } else if (currentSection == 2) {
            gsap.to(objectsToUpdate[0].rotation, { duration: 1.5, ease: 'power2.inOut', x: '+=6', y: '+=3', z: '+=1.5' })
            gsap.to(objectsToUpdate[1].rotation, { duration: 1.5, ease: 'power2.inOut', x: '+=6', y: '+=3', z: '+=1.5' })
        }
    }
    /* New Scroll Functionality */
    // const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    // const scrollFactor = scrollY / maxScroll;

    // // Interpolate background color
    // const bgColor = interpolateColor(bgColorStart, bgColorEnd, scrollFactor);
    // document.body.style.backgroundColor = `#${bgColor.getHexString()}`;

    // // Interpolate text color
    // const textColor = interpolateColor(textColorStart, textColorEnd, scrollFactor);
    // document.body.style.color = `#${textColor.getHexString()}`;

    // // Update other elements' text color if needed
    // document.querySelectorAll('.section, .section h2, .section p').forEach(el => {
    //     el.style.color = `#${textColor.getHexString()}`;
    // });
    changeColorSetup()
})

/** * Cursor */
const cursor = {}
cursor.x = 0
cursor.y = 0

window.addEventListener('mousemove', (event) => {
    cursor.x = event.clientX / sizes.width - 0.5
    cursor.y = event.clientY / sizes.height - 0.5
})

/** * Animate */
const clock = new THREE.Clock()
let previousTime = 0
let customModel

const tick = () => {
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Animate camera
    camera.position.y = - scrollY / sizes.height * objectsDistance

    const parallaxX = cursor.x * 0.5
    const parallaxY = - cursor.y * 0.5
    cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 5 * deltaTime
    cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 5 * deltaTime

    // Oscillation between 1 and 1.5
    const oscillation = 1.25 + 0.25 * Math.cos(elapsedTime * 2 / 10)  // Adjust the multiplier to control the speed of oscillation

    for (const object of objectsToUpdate) {
        object.rotation.x += deltaTime * 0.1
        object.rotation.y += deltaTime * 0.12
        object.scale.x = oscillation
        object.scale.y = oscillation
        object.scale.z = oscillation

    }
    renderer.render(scene, camera)
    window.requestAnimationFrame(tick)
}
tick()
